
export default {
    name: 'LeeSwitch',
    inheritAttrs: false,
    data() {
        return {};
    },
    mounted() {
        if (this.value === false) {
            if (this.mode) {
                if (this.getItem('mode')) {
                    this.$emit('input', true)
                    this.setItem('mode', 1, 1)
                    document.documentElement.classList.add('dark')
                } else {
                    this.$emit('input', false)
                    this.removeItem('mode')
                    document.documentElement.classList.remove('dark')
                }
            }

        } else {
            if (this.mode) {
                if (!this.getItem('mode')) {
                    this.$emit('input', false)
                    this.removeItem('mode')
                    document.documentElement.classList.remove('dark')
                } else {
                    this.$emit('input', true)
                    this.setItem('mode', 1, 1)
                    document.documentElement.classList.add('dark')
                }

            }
        }
        // if (this.getItem('mode')) {
        //     this.$emit('input', true)
        //     if (this.mode) {
        //         document.documentElement.classList.add('dark')
        //     }
        // } else {
        //     this.$emit('input', false)
        //     if (this.mode) {
        //         document.documentElement.classList.remove('dark')
        //     }
        // }
    },
    methods: {
        chuli() {
            if (this.value === false) {
                this.$emit('input', true)
                if (this.mode) {
                    this.setItem('mode', 1, 1)
                    document.documentElement.classList.add('dark')
                }
            } else {
                this.$emit('input', false)
                if (this.mode) {
                    this.removeItem('mode')
                    document.documentElement.classList.remove('dark')
                }
            }
        },
        setItem(key, data, time) {
            try {
                if (!localStorage) {
                    return false;
                }
                var cacheExpireDate = new Date().getTime() + time * 60 * 60 * 24 * 1000;
                var cacheVal = {val: data, exp: cacheExpireDate};
                localStorage.setItem(key, JSON.stringify(cacheVal)); //存入缓存值
            } catch (e) {
                console.log(e)
            }
        },
        getItem(key) {
            try {
                if (!localStorage) {
                    return false;
                }
                var cacheVal = localStorage.getItem(key);
                var result = JSON.parse(cacheVal);
                var now = new Date().getTime();
                //缓存不存在
                if (!result) {
                    return null;
                }
                //缓存过期
                if (now > result.exp) {
                    this.removeItem(key);
                    return "";
                }
                return result.val;
            } catch (e) {
                this.removeItem(key);
                return null;
            }
        },
        removeItem(key) {
            if (!localStorage) {
                return false;
            }
            localStorage.removeItem(key);
        }
    },
    props: {
        mode: {
            type: Boolean,
            default: false //false
        },
        value: {
            type: Boolean,
            default: false //false
        },
        color: {
            type: String,
            default: '#46bd87' //#46bd87
        },
        size: {
            type: String,
            default: 's' //s
        },
        startText: {
            type: String,
            default: '开' //s
        },
        endText: {
            type: String,
            default: '关' //s
        },
    }
};
